module.exports = __webpack_public_path__ + "img/landing-image-01.df2e7a04.png";